/**
 * `calendarSettingsFromMonday()` — read monday's `CalendarBoardView.settings_str`
 * (`specs/M4-V4-calendar.md` §4). Four of the five production rows are `{}`; the fifth is the
 * only evidence for every key below.
 */
import { columnSelectionFromMonday, singleColumnFromMonday } from '../column-selection.js';
import { extraKeys, parseViewSettingsBlob, presentKeys } from '../from-monday.js';
import { CALENDAR_MONDAY_KEYS, DEFAULT_CALENDAR_VIEW_SETTINGS, } from './index.js';
export function calendarSettingsFromMonday(raw) {
    const { object, warnings } = parseViewSettingsBlob(raw, 'calendar');
    const d = DEFAULT_CALENDAR_VIEW_SETTINGS;
    const bool = (key, fallback) => {
        const value = object[key];
        if (typeof value === 'boolean')
            return value;
        if (value !== undefined)
            warnings.push(`calendar: ${key} is not a boolean`);
        return fallback;
    };
    return {
        settings: {
            dateColumns: columnSelectionFromMonday(object['columns']),
            colorColumnId: singleColumnFromMonday(object['color_by_id']),
            showTimeSlots: bool('show_time_slots', d.showTimeSlots),
            displayLegend: bool('display_legend', d.displayLegend),
            range: d.range,
            weekStartsOn: d.weekStartsOn,
            mondayKeys: presentKeys(object, CALENDAR_MONDAY_KEYS),
            mondayExtras: extraKeys(object, CALENDAR_MONDAY_KEYS),
        },
        warnings,
    };
}
//# sourceMappingURL=from-monday.js.map